import React from "react";
import { Table, Button } from "react-bootstrap";
import "../../assets/css/Apps/AppsTable.css";
import { truncate } from "../../helpers/utils";
import { APP_TABLE_HEADERS } from "../../constants/Dashboard/appConstants";

const AppsTable = ({ apps, onEdit, onDelete }) => {
  if (!apps || apps.length === 0) {
    return (
      <div className="emptyState">
        <h3 className="emptyHeading">No Apps Found</h3>
        <p className="emptyText">Get started by creating your first app</p>
      </div>
    );
  }

  return (
    <div className="tableContainer">
      <Table responsive className="table">
        <thead className="tableHeader">
          <tr>
            {APP_TABLE_HEADERS.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {apps.map((app, index) => (
            <tr key={app.id} className="tableRow">
              <td>{index + 1}</td>
              <td>{truncate(app.station_name)}</td>
              <td>{truncate(app.app_name)}</td>
              <td>{truncate(app.alias || "#N/A")}</td>
              <td>{truncate(app.Project || "N/A")}</td>
              <td>{truncate(app.sku || "N/A")}</td>
              <td className="actions">
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="actionButton"
                  onClick={onEdit(app)}
                >
                  EDIT
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="actionButton"
                  onClick={onDelete(app)}
                >
                  DELETE
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AppsTable;
